import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import type { GsmMediaType } from '@models/gsm.model';

/**
 * Returns the desired display name of a media type.
 * e.g.: "TestType (TTE)"
 *
 * @param item Media type that's name should be displayed
 * @param notAnnouncedText Text that should be display if no name and code provided
 */
@Pipe({
  name: 'foerchGsmDisplayName',
  standalone: true,
})
export class FoerchGsmDisplayNamePipe implements PipeTransform {
  private _notAnnouncedText = 'n.a.';

  transform(item: GsmMediaType): string {
    if (!item || (!item.name && !item.code)) {
      return this._notAnnouncedText;
    } else if (item.name && item.code) {
      return `${item.name} (${item.code})`;
    } else {
      return item.name || item.code;
    }
  }
}
